// authActions.js
import { LOGIN_FAIL, LOGIN_SUCCESS, LOGOUT } from '../types';

export const loginSuccess = (token, user) => ({
  type: LOGIN_SUCCESS,
  payload: { token, user }, // Include user details in the payload
});

export const loginFail = () => ({
  type: LOGIN_FAIL,
  payload: {},
});

// LOGOUT was declared in types.js and handled by the reducer but never had an
// action creator, so nothing could actually dispatch it.
export const logout = () => ({
  type: LOGOUT,
  payload: {},
});
